import {MomentService} from "./../../../services/moment.service";
import {FilterObject} from "./filter-object";

export class BetweenDatesFilter extends FilterObject<any> {

  momentService: MomentService;

  constructor() {
    super();
    this.momentService = new MomentService();
  }

  public filter(itemToFiltre: any): boolean {
    return this.doFilter(itemToFiltre, this.field, this.values);
  }

  public doFilter(itemToFiltre: any, field: any, value: any): boolean {
    let dateChamp = itemToFiltre[field];

    let dateModif = this.momentService.parse(dateChamp);

    let dateDebut = this.momentService.parse(value[0]);
    let dateFin = this.momentService.parse(value[1]);

    return (dateModif.isSameOrAfter(dateDebut,'day') && dateModif.isSameOrBefore(dateFin, 'day'));
  }
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/components/filter/filters/between-dates.filter.ts